<template>
  <div>
    <Loader v-model="loading" />
    <PrinterDialog v-model="printer" :impresoras="impresoras" />
    <PrinterDialog v-model="printerCorte" :impresoras="impresoras" />
    <v-app-bar app>
      <v-app-bar app color="primary" dark>
        <v-icon @click="goBack">mdi-keyboard-backspace</v-icon>
        <v-spacer></v-spacer>
        <v-toolbar-title>Administrador de Tickets</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon>mdi-account-circle</v-icon> {{ session.usuario.toUpperCase() }}
      </v-app-bar>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title> Informacion </v-card-title>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col>
                      <v-select v-model="version" :items="versiones" label="Tipo" item-text="name" item-value="value"
                        outlined>
                      </v-select>
                    </v-col>
                    <v-col>
                      <v-text-field type="date" label="Fecha Inicio" outlined
                        v-model="info.fecha_inicio"></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field type="date" label="Fecha Final" outlined v-model="info.fecha_fin"></v-text-field>
                    </v-col>
                    <v-col>
                      <v-combobox placeholder="Todos" :items="usuarios" item-text="strUsuarioPOS"
                        item-value="strUsuarioPOS" v-model="info.usuario" label="Usuario" outlined
                        :return-object="false" dense>
                      </v-combobox>
                    </v-col>
                    <v-col md="1">
                      <v-btn x-large block color="primary" @click="buscar()">
                        Buscar
                      </v-btn>
                    </v-col>

                  </v-row>
                  <v-row>
                    <v-col >
                    <v-btn x-large block color="primary" @click="printGlobal()">
                      Imprimir Corte Global
                    </v-btn>
                  </v-col>
                  <v-col >
                    <v-btn x-large block color="primary" @click="printOrdenes()">
                      Imprimir Grupo de Tickets de venta
                    </v-btn>
                  </v-col>
                  </v-row>
                  
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>Resultados</v-card-title>
              <v-card-text>
                <v-container fluid>
                  <v-row v-show="visibleVenta">
                    <v-col>

                      <!-- ================= VENTAS ================= -->
                      <v-data-table :headers="headers" :items="results" item-key="intPOSEnc" show-expand single-expand
                        :expanded.sync="expandedVentas" @item-expanded="loadDetalleVenta">
                        <!-- Folio -->
                        <template #item.intFolio="{ item }">
                          {{ item.intFolio }}
                        </template>

                        <!-- Fecha -->
                        <template #item.datFecha="{ item }">
                          {{ toDateString(item.datFecha, 1) }}
                        </template>

                        <!-- Factura -->
                        <template #item.intOrden="{ item }">
                          {{ item.intOrden }}
                        </template>

                        <!-- Estatus -->
                        <template #item.intEstatus="{ item }">
                          {{ getEstatus(item.intEstatus) }}
                        </template>

                        <!-- Tipo -->
                        <template #item.intPOSTipoServicio="{ item }">
                          {{ getServicio(item.intPOSTipoServicio) }}
                        </template>

                        <!-- Metodo de Pago -->
                        <template #item.nombrePago="{ item }">
                          {{ item.nombrePago }}
                        </template>

                        <!-- Importe -->
                        <template #item.importe="{ item }">
                          {{ isMoney(item.importe) }}
                        </template>

                        <!-- Referencia -->
                        <template #item.strMesa="{ item }">
                          {{ item.strMesa || '-' }}
                        </template>

                        <!-- Subtotal -->
                        <template #item.dblSubtotal="{ item }">
                          {{ isMoney(item.dblSubtotal) }}
                        </template>

                        <!-- Total -->
                        <template #item.dblTotal="{ item }">
                          {{ isMoney(item.dblTotal) }}
                        </template>

                        <!-- Usuario -->
                        <template #item.strUsuarioPOS="{ item }">
                          {{ item.strUsuarioPOS ? item.strUsuarioPOS.toUpperCase() : '' }}
                        </template>
                        <!-- FOOTER -->
                        <template #body.append="{ headers }">
                          <tr class="summary">
                            <td v-for="(header, i) in headers" :key="i">
                              <div v-if="header.text == 'Subtotal'">
                                {{ isMoney(sumField('dblSubtotal')) }}
                              </div>
                              <div v-if="header.text == 'Total'">
                                {{ isMoney(sumField('dblTotal')) }}
                              </div>
                            </td>
                          </tr>
                        </template>

                        <!-- ============== EXPAND VENTA ============== -->
                        <template #expanded-item="{ item, headers }">
                          <td :colspan="headers.length">
                            <v-data-table :headers="headersDetalle" :items="item.detalle || []" item-key="intPOSDet"
                              show-expand single-expand :expanded.sync="item._expandedDetalle" dense class="elevation-1"
                              @item-expanded="loadConfiguracionDetalle">
                              <template #item.dblPU="{ item }">
                                {{ isMoney(item.dblPU) }}
                              </template>

                              <template #item.dblTotal="{ item }">
                                {{ isMoney(item.dblTotal) }}
                              </template>

                              <!-- ===== CONFIGURACION ===== -->
                              <template #expanded-item="{ item: detalleItem, headers }">
                          <td :colspan="headers.length">
                            <v-data-table :headers="headersConfig" :items="detalleItem.configuracion || []" dense
                              hide-default-footer>
                              <template #item.dblCantidad="{ item }">
                                {{ item.dblCantidad }}
                              </template>
                            </v-data-table>
                          </td>
                        </template>
                      </v-data-table>
                      </td>
</template>
</v-data-table>

</v-col>
</v-row>


<v-row v-show="visibleSalidas">
  <v-col>
    <v-data-table :headers="salidaCaja" :items="resultsSalidas">
      <template v-slot:[`item.dblImporte`]="{ item }">
        {{ isMoney(item.dblImporte) }}
      </template>
      <template v-slot:[`item.intPOSSalidaCaja`]="{ item }">
        <v-icon small @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="printSalidas(item)"> mdi-print </v-icon>
      </template>
      <template v-slot:[`body.append`]="{ headers }">
        <tr class="summary">
          <td v-for="(header, i) in headers" :key="i">
            <div v-if="header.text == 'Importe'">
              {{ isMoney(sumFieldSC('dblImporte')) }}</div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-col>
</v-row>
<v-row v-show="visibleArqueos">
  <v-col>
    <v-data-table :headers="arqueos" :items="resultsArqueos">
      <template v-slot:[`item.dblImporte`]="{ item }">
        {{ isMoney(item.dblImporte) }}
      </template>
      <template v-slot:[`item.intPOSTipoMovimientoTurno`]="{ item }">
        {{ getMovimiento(item.intPOSTipoMovimientoTurno) }}
      </template>
      <template v-slot:[`item.intPOSRegister`]="{ item }">
        <v-icon small @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="printArqueos(item)"> mdi-printer </v-icon>
      </template>
      <template v-slot:[`body.append`]="{ headers }">
        <tr class="summary">
          <td v-for="(header, i) in headers" :key="i">
            <div v-if="header.text == 'Importe'">
              {{ isMoney(sumFieldAr('dblImporte')) }}</div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-col>
</v-row>
</v-container>
</v-card-text>
</v-card>
</v-col>
</v-row>
</v-container>
</v-main>
</div>
</template>

<script>
import Loader from "../components/Loader.vue";
//import { Session, Toast, ErrorWeb,Dialog } from "../controllers/DataController.js";
import { Data, Dialog, Toast, Session, ErrorWeb } from "../controllers/DataController.js";
import { POSEncFunctions } from "../controllers/POSController";
import { isMoney, toDateString } from "../js/utilities";
//import { Data } from "../controllers/DataController.js";
import { POSSalidaCaja, POSSalidaCajaFunctions } from "../controllers/POSController";
import { POSRegister, POSRegisterFunctions } from "../controllers/RegisterController.js";
import { POSTerminalFunctions } from "../controllers/POSController.js";
import moment from "moment";
import PrinterDialog from "../components/PrinterDialogComponent.vue";
import Cookies from "js-cookie";




export default {
  data() {
    return {


      // expand nivel ventas
      expandedVentas: [],

      headers: [
        { text: '', value: 'data-table-expand' },

        { text: 'Folio', value: 'intFolio' },
        { text: 'Fecha', value: 'datFecha' },
        { text: 'Factura', value: 'intOrden' },
        { text: 'Usuario', value: 'strUsuarioPOS' },
        { text: 'Tipo', value: 'intPOSTipoServicio' },
        { text: 'Estatus', value: 'intEstatus' },
        { text: 'Metodo de Pago', value: 'nombrePago' },
        { text: 'Referencia', value: 'strMesa' },

        { text: 'Importe', value: 'importe' },
        { text: 'Subtotal', value: 'dblSubtotal' },
        { text: 'Total', value: 'dblTotal' }
      ],

      headersDetalle: [
        { text: '', value: 'data-table-expand' },
        { text: 'Clave', value: 'strNombreCorto' },
        { text: 'Artículo', value: 'strNombre' },
        { text: 'PU', value: 'dblPU' },
        { text: 'Cantidad', value: 'dblCantidad' },
        { text: 'Total', value: 'dblTotal' }
      ],

      headersConfig: [
        { text: 'Configuración', value: 'strNombre' },
        { text: 'Cantidad', value: 'dblCantidad' }
      ],

      session: new Session(),
      dataFunctions: new Data(),
      ordenFunctions: new POSEncFunctions(),
      salida: new POSSalidaCaja(),
      datacierreCorte: null,
      salidaFunctions: new POSSalidaCajaFunctions(),
      registerFunctions: new POSRegisterFunctions(),
      terminalFunctions: new POSTerminalFunctions(),
      printerCorte: new Dialog(0, 0, "", "", ""),
      registro: new POSRegister(),
      printer: new Dialog(0, 0, "", "", ""),
      nombreTerminal: "",
      usuarios: [],
      title: this.$config.ordenTitle,
      impresoras: [],
      versiones: [
        { value: 1, name: "Ventas" },
        { value: 2, name: "Salidas de Caja" },
        { value: 3, name: "Arqueos obligatorios" },
      ],
      version: 1,
      info: {
        usuario: "",
        // fecha_inicio:  moment(new Date()).format("DD/MM/YYYY"),//format("yyyy-MM-DD"),
        // fecha_fin:moment().format("DD/MM/YYYY"),//format("yyyy-MM-DD"),
        fecha_inicio: moment().format("yyyy-MM-DD"),
        fecha_fin: moment().format("yyyy-MM-DD"),
        intPOSRegister: "0"

      },
      loading: false,
      // headers: [
      //   { text: "Folio", value: "intFolio" },
      //   { text: "Fecha", value: "datFecha" },
      //   { text: 'Factura', value: "intOrden" },
      //   { text: "Estatus", value: "intEstatus" },
      //   { text: "Tipo", value: "intPOSTipoServicio" },
      //   { text: "Metodo de Pago", value: "strNombre" },
      //   { text: "Importe", value: "importe" },
      //   { text: "Referencia", value: "strMesa" },
      //   { text: "Subtotal", value: "dblSubtotal" },
      //   { text: "Total", value: "dblTotal" },
      //   { text: "Usuario", value: "strUsuarioPOS" },
      // ],
      // headersDetalle: [
      //   { text: 'Clave', value: 'strNombreCorto' },
      //   { text: 'Artículo', value: 'strNombre' },
      //   { text: 'PU', value: 'dblPU' },
      //   { text: 'Cantidad', value: 'dblCantidad' },
      //   { text: 'Total', value: 'dblTotal' },
      //   { text: '', value: 'data-table-expand' }
      // ],
      // headersConfig: [
      //   { text: 'Configuración', value: 'strNombre' },
      //   { text: 'Cantidad', value: 'dblCantidad' }
      // ],

      salidaCaja: [
        // {text: "#", value: "intPOSTipoSalida", align: ' d-none' },
        { text: "Tipo Salida", value: "strTipoSalida" },
        { text: "Salida", value: "strSalida" },
        { text: "Importe", value: "dblImporte" },
        { text: "Comentario", value: "strComentario" },
        { text: "Empleado", value: "strEmpleado" },
        { text: "Acciones", value: "intPOSSalidaCaja" },
      ],
      arqueos: [
        { text: "Folio", value: "intFolio" },
        { text: "Importe", value: "dblImporte" },
        { text: "Captura", value: "strUsuarioPOS" },
        { text: "Comentario", value: "strComentario" },
        { text: "Tipo", value: "intPOSTipoMovimientoTurno" },
        { text: "Acciones", value: "intPOSRegister" },
      ],
      results: [],
      POSInfo: null,
      resultsSalidas: [],
      terminal: null,
      resultsArqueos: [],
      visibleVenta: true,
      visibleSalidas: false,
      visibleArqueos: false,
      config_21: this.$config.opciones.find((c) => c.id == 21)
    };
  },
  components: {
    Loader, PrinterDialog,
  },
  watch: {
    ["version"](newVal) {
      if (newVal == 1) {
        this.visibleVenta = true,
          this.visibleSalidas = false,
          this.visibleArqueos = false
      } else if (newVal == 2) {
        this.visibleVenta = false,
          this.visibleSalidas = true,
          this.visibleArqueos = false

      } else {
        this.visibleVenta = false,
          this.visibleSalidas = false,
          this.visibleArqueos = true
      }
    },
  },
  methods: {
    sumField(key) {
      // console.log(key)
      // sum data in give key (property) 
      return this.results.reduce((a, b) => a + (b[key] || 0), 0)
    },
    sumFieldSC(key) {
      // console.log(key)
      // sum data in give key (property)
      return this.resultsSalidas.reduce((a, b) => a + (b[key] || 0), 0)
    },
    sumFieldAr(key) {
      // console.log(key)
      // sum data in give key (property)
      return this.resultsArqueos.reduce((a, b) => a + (b[key] || 0), 0)
    },
    isMoney: isMoney,
    toDateString: toDateString,
    getEstatus(intEstatus) {
      if (intEstatus == 2) {
        return "PREPARACION";
      } else if (intEstatus == 4) {
        return "PAGADA";
      } else if (intEstatus == 8 || intEstatus == 9) {
        return "CANCELADA";
      } else return intEstatus;
    },
    goBack() {
      Cookies.remove("POS_USER");
      Cookies.remove("POS_TERMINAL");
      Cookies.remove("POS_REGISTER_CAJA");
      Cookies.remove("POS_TIPO");
      this.$router.push("/Login");
    },
    getServicio(servicio) {
      let config_21 = this.$config.opciones.find((c) => c.id == 21);
      if (config_21.valor) {
        if (servicio == 2) return "FACTURA";
      }
      else {
        if (servicio == 1) return "MESA";
        else if (servicio == 2) return "DOMICILIO";
        else if (servicio == 3) return "LLEVAR";
      }

    },
    getMovimiento(intPOSTipoMovimientoTurno) {
      if (intPOSTipoMovimientoTurno == 1) return "APERTURA";
      else if (intPOSTipoMovimientoTurno == 2) return "ARQUEO";
      else if (intPOSTipoMovimientoTurno == 3) return "CIERRE";
    },
    getExpandedDetalle(venta) {
      // si no existe, lo crea reactivo
      if (!venta._expandedDetalle) {
        this.$set(venta, '_expandedDetalle', [])
      }
      return venta._expandedDetalle
    },

    async loadDetalleVenta({ item, value }) {
      // Solo cargar cuando se expande
      if (!value) return;

      try {
        this.loading = true;
        // Verificar si ya tiene detalle
        if (!item.detalle || item.detalle.length === 0) {
          const detalle = await this.ordenFunctions.getDetalleVenta(item.intPOSEnc);

          // Inicializar cada detalle con su propio control de expansión
          const detalleConConfig = (detalle || []).map(d => ({
            ...d,
            configuracion: [],
            _expandedDetalle: [] // Control individual para cada detalle
          }));

          this.$set(item, 'detalle', detalleConConfig);
        }
      } catch (error) {
        console.error('Error cargando detalle:', error);
        this.$toast.error('Error al cargar el detalle');
      } finally {
        this.loading = false;
      }
    },

    async loadConfiguracionDetalle({ item, value }) {

      // solo cuando se expande
      if (!value) return;

      try {

        // evitar recargas
        if (item.configuracion && item.configuracion.length > 0)
          return;

        const configuracion =
          await this.ordenFunctions.getDetalleVentaConfiguracion(
            item.intPOSDet
          );

        this.$set(item, 'configuracion', configuracion || []);

      } catch (error) {
        console.error('Error cargando configuración:', error);
        this.$toast.error('Error al cargar configuración');
      }
    },

    async buscar() {
      this.loading = true;
      try {

        // if( this.version == 2 && this.info.usuario ==  "")
        //   throw "Seleccione un Usuario";

        if (this.version == 1) {
          this.results = await this.ordenFunctions.administradorTicket(
            this.session.empresa,
            this.version,
            this.info
          );
          console.log(this.results);
          // Reiniciar expandedVentas
          this.expandedVentas = [];

          // Inicializar cada venta
          this.results = this.results.map(venta => ({
            ...venta,
            detalle: [],
            _expandedDetalle: []
          }));

          console.log(this.results);

        } else if (this.version == 2) {
          // Actualizar la carga de usuarios con filtro de fechas
          this.usuarios = await this.dataFunctions.loadUsuariosOrdenesFecha(
            this.info.fecha_inicio,
            this.info.fecha_fin
          );

          const usuarioEncontrado = this.usuarios.find(x => x.strUsuarioAlta == this.info.usuario);
          let intPOSRegister = usuarioEncontrado ? usuarioEncontrado.intPOSRegister : 0;
          this.info.intPOSRegister = String(intPOSRegister);

          if (intPOSRegister == 0) {
            throw "Seleccione un usuario";
          }


          this.resultsSalidas = await this.ordenFunctions.administradorTicket(
            this.session.empresa,
            this.version,
            this.info
          );
        } else if (this.version == 3) {
          this.resultsArqueos = await this.ordenFunctions.administradorTicket(
            this.session.empresa,
            this.version,
            this.info
          );
        }

      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },

    async printOrdenes() {
  this.loading = true;

  try {
    if (this.version !== 1 || !this.results || this.results.length === 0) {
      alert("PRIMERO NECESITA BUSCAR UN RANGO DE FECHAS Y CARGAR VENTAS");
      return;
    }

    for (const item of this.results) {

      const ordenBase = await this.ordenFunctions.getOrdenReimpresionXintPOSEnc(
        this.version,
        item.intPOSEnc
      );

      ordenBase.POSInfo = this.POSInfo;
      ordenBase.StrTerminal = ordenBase.strMaquinaAlta;
      ordenBase.posEncPago = await this.ordenFunctions.pagos(ordenBase.intPOSEnc);

      if (!ordenBase.posDet)
        ordenBase.posDet = await this.ordenFunctions.detalles(ordenBase.intPOSEnc);

      ordenBase.datFechaImpresion = this.toIsoString(new Date());

      //  CLAVE: destruir instancia anterior
      this.printer.visible = false;
      this.printer.printable = null;

      await this.$nextTick();

      //  Clonar para evitar reutilización reactiva
      const orden = JSON.parse(JSON.stringify(ordenBase));

      this.printer.event = "pago";
      this.printer.printable = orden;
      this.printer.visible = true;

      await this.$nextTick();

      //  Esperar tiempo real suficiente
      await new Promise(resolve => setTimeout(resolve, 1500));
    }

  } catch (e) {
    this.$toast.error(ErrorWeb(e), new Toast());
  } finally {
    this.loading = false;
  }
},

    async printGlobal() {
      this.loading = true;
      try {

        let posRegisterGlobal = await this.registerFunctions.getRegisterGlobal(this.info.fecha_inicio);

        if (!posRegisterGlobal)
      {
        alert("NO SE ENCONTRO CORTE GLOBAL");
          return;
      }

        console.log(this.info.fecha_inicio);
        console.log(this.info.fecha_fin);
        if (this.info.fecha_inicio !== this.info.fecha_fin) {
          alert("DEBE ESCOGER UNA SOLA FECHA PARA SACAR CORTE GLOBAL");
          return;
        }

        let POSRegister1 = await this.ordenFunctions.getArqueos(posRegisterGlobal.intPOSRegister)
          this.datacierre = await this.registerFunctions.cierreReimpresion(posRegisterGlobal.intPOSRegister);
          console.log("POSRegister1")
          console.log(POSRegister1)
          // Calcular importe entregado
          const dblImporteEntregado =
            (this.datacierre?.dblRetiros || 0) +
            (this.registro?.dblOtrosPagos || 0) +
            (this.datacierre?.dblSalidas || 0);

          // Armar el objeto base del ticket
          let POSRegister = {
            strMaquinaAlta: POSRegister1?.strMaquinaAlta || "",
            strUsuarioPOS: POSRegister1?.strUsuarioPOS || "",
            datFechaAlta: this.datacierre?.datFechaInicioTurno
              ? new Date(this.datacierre.datFechaInicioTurno + "Z")
              : null,
            strTerminal: this.nombreTerminal?.strNombre || "",
            dblImporteEntregado,
            // dblDiferencia: dblImporteEntregado - (this.datacierre?.dblVenta || 0),
            // dblImporte: dblImporteEntregado,
            // dblVenta: this.datacierre?.dblVenta || 0,
            // intTotalOrdenesVenta: this.datacierre?.intTotalOrdenesVenta || 0,
            // intTotalPlatillosVenta: this.datacierre?.intTotalPlatillosVenta || 0,
            // intCortesiaCta: this.datacierre?.intCortesiaCta || 0,
            // intCortesiaPlat: this.datacierre?.intCortesiaPlat || 0
          };

          console.log("POSREGISTER ANTES DE DATOS GLOBAL")

          console.log(POSRegister)
          console.log(this.datacierre)


          POSRegister.pagos = await this.registerFunctions.pagosGlobalReimpresion(POSRegister1.intPOSRegisterPadre) || [];
          // POSRegister.salidas = await this.registerFunctions.salidasReimpresion(POSRegister1.intPOSRegisterPadre);
          // POSRegister.dblVentas = await this.registerFunctions.ventasReimpresion(POSRegister1.intPOSRegisterPadre);

          // Complementar con datos del corte
          this.datacierreCorte = await this.registerFunctions.corteGlobal(
            0 || 0,
            POSRegister1.datFechaInicio
          );

          Object.assign(POSRegister, {

            //dblVenta: this.datacierreCorte?.dblVenta || 0,
            dblVenta: this.datacierreCorte?.dblVentaConImpuesto || 0,
            //dblVentaSinImpuesto: this.datacierreCorte?.dblVentaSinImpuesto || 0,
            dblVentaSinImpuesto: this.datacierreCorte?.dblVentaSinImpuesto || 0,
            intEnvios: this.datacierreCorte?.intEnvios || 0,
            dblEnvios: this.datacierreCorte?.dblEnvios || 0,
            //intEnvios: this.datacierreCorte?.intEnvios || 0,
            // dblEnvios: this.datacierreCorte?.dblEnvios || 0,
            dblVentaConImpuesto: this.datacierreCorte?.dblVenta || 0,
            //dblVentaConImpuesto: this.datacierreCorte?.dblVentaConImpuesto || 0,
            
            intTotalOrdenesVenta: this.datacierreCorte?.intTotalOrdenesVenta || 0,
            intTotalPlatillosVenta: this.datacierreCorte?.intTotalPlatillosVenta || 0,
            intCortesiaCta: this.datacierreCorte?.intCortesiaCta || 0,
            intCortesiaPlat: this.datacierreCorte?.intCortesiaPlat || 0,
            intPromCta: this.datacierreCorte?.intPromCta || 0,
            dblPromCta: this.datacierreCorte?.dblPromCta || 0,
            intCancelacionCta: this.datacierreCorte?.intCancelacionCta || 0,
            dblCancelacionCta: this.datacierreCorte?.dblCancelacionCta || 0,
            intCancelacionPlat: this.datacierreCorte?.intCancelacionPlat || 0,
            dblCancelacionPlat: this.datacierreCorte?.dblCancelacionPlat || 0,
            intDescuentoCta: this.datacierreCorte?.intDescuentoCta || 0,
            dblDescuentoCta: this.datacierreCorte?.dblDescuentoCta || 0,
            intDescuentoPlat: this.datacierreCorte?.intDescuentoPlat || 0,
            dblDescuentoPlat: this.datacierreCorte?.dblDescuentoPlat || 0,
            intDevolucionCta: this.datacierreCorte?.intDevolucionCta || 0,
            dblDevolucionCta: this.datacierreCorte?.dblDevolucionCta || 0,
            intDevolucionPlat: this.datacierreCorte?.intDevolucionPlat || 0,
            dblDevolucionPlat: this.datacierreCorte?.dblDevolucionPlat || 0,
            intOrdenesDomicilio: this.datacierreCorte?.intOrdenesDomicilio || 0,
            dblTotalDomicilio: this.datacierreCorte?.dblTotalDomicilio || 0,
            intOrdenesLLevar: this.datacierreCorte?.intOrdenesLLevar || 0,
            dblTotalLLevar: this.datacierreCorte?.dblTotalLLevar || 0,
            intOrdenesMesa: this.datacierreCorte?.intOrdenesMesa || 0,
            dblTotalMesa: this.datacierreCorte?.dblTotalMesa || 0,
            dblFondoCaja: this.datacierreCorte?.dblFondoCaja || 0,
            dblEntregaReal: this.datacierreCorte?.dblEntregaReal || 0,
            dblDiferencia: this.datacierreCorte?.dblDiferencia || 0,
            intRetiroObligatorio: this.datacierreCorte?.intRetiroObligatorio || 0,
            dblRetiroObligatorio: this.datacierreCorte?.dblRetiroObligatorio || 0,
            dblComisiones: this.datacierreCorte?.dblComisiones || 0,
            intIntentos: this.datacierreCorte?.intIntentos || 0,
            dblCompras: this.datacierreCorte?.dblCompras || 0,
            intOrdenesRappi: this.datacierreCorte?.intOrdenesRappi || 0,
            dblTotalRappi: this.datacierreCorte?.dblTotalRappi || 0,
            intOrdenesUber: this.datacierreCorte?.intOrdenesUber || 0,
            dblTotalUber: this.datacierreCorte?.dblTotalUber || 0,
            intOrdenesDidi: this.datacierreCorte?.intOrdenesDidi || 0,
            dblTotalDidi: this.datacierreCorte?.dblTotalDidi || 0
          });

          // Preparar para imprimir
          this.printer.event = "corteGlobal";
          this.printer.visible = true;
          this.printer.printable = POSRegister;
          console.log(POSRegister);
          console.log("Ticket listo para imprimir:", POSRegister);

      }
      catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      }
      finally {
        this.loading = false;
      }


    },
    // async buscar() {
    //   this.loading = true;
    //   try {

    //     if( this.version == 2 && this.info.usuario ==  "")
    //       throw "Seleccione un Usuario";

    //       if(this.version == 1){
    //         this.results = await this.ordenFunctions.administradorTicket(
    //           this.session.empresa,
    //           this.version,
    //           this.info
    //         );
    //       }else if(this.version == 2){
    //         let intPOSRegister =this.usuarios.find(x => x.strUsuarioAlta== this.info.usuario).intPOSRegister;
    //         this.info.intPOSRegister =String(intPOSRegister);

    //           this.resultsSalidas = await this.ordenFunctions.administradorTicket(
    //           this.session.empresa,
    //           this.version,
    //           this.info
    //        );
    //       }else if(this.version == 3){
    //         this.resultsArqueos = await this.ordenFunctions.administradorTicket(
    //           this.session.empresa,
    //           this.version,
    //           this.info
    //         );

    //       }


    //   } catch (e) {
    //     this.$toast.error(ErrorWeb(e), new Toast());
    //   } finally {
    //     this.loading = false;
    //   }
    // },


    async printSalidas(item) {
      console.log(item.strTipoSalida, item.strSalida, item.strEmpleado)
      this.loading = true;
      try {
        this.salida = await this.salida.RetrieveCaja_id(item.intPOSSalidaCaja);
        console.log(this.salida)
        if (item.intPOSTipoSalida == 2) {
          if (!this.salida.dataDetalleComision)
            this.salida.dataDetalleComision = await this.salida.RetrieveCaja(item.intPOSSalidaCaja);
        }
        this.salida.strPOSTipoSalida = item.strTipoSalida;
        this.salida.strPOSSalida = item.strSalida;
        this.salida.strUsuarioSalida = this.session.usuario;
        this.salida.strEmpleado = item.strEmpleado

        this.salida.POSInfo = this.POSInfo;
        this.salida.StrTerminal = this.session.terminal
        this.salida.strUsuarioAlta = this.session.usuario;
        this.salida.datFechaAlta = this.toIsoString(new Date());


        console.log("salida", this.salida)

        if (this.config_21.valor) {
          this.printer.event = "salidaCajaDicex";
        }
        else
          this.printer.event = "salidaCaja";

        this.printer.visible = true;
        this.printer.printable = this.salida;
        console.log("salida", this.salida)
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
    async printArqueos(item) {
      this.loading = true;
      try {

        if (item.intPOSTipoMovimientoTurno == 2) {
          let POSRegister = await this.ordenFunctions.getArqueos(item.intPOSRegister)
          this.printer.event = "arqueo";
          this.printer.visible = true;
          this.printer.printable = POSRegister;
        }
        if (item.intPOSTipoMovimientoTurno == 3) {
          let POSRegister1 = await this.ordenFunctions.getArqueos(item.intPOSRegister)
          this.datacierre = await this.registerFunctions.cierreReimpresion(item.intPOSRegister);
          console.log("POSRegister1")
          console.log(POSRegister1)
          // Calcular importe entregado
          const dblImporteEntregado =
            (this.datacierre?.dblRetiros || 0) +
            (this.registro?.dblOtrosPagos || 0) +
            (this.datacierre?.dblSalidas || 0);

          // Armar el objeto base del ticket
          let POSRegister = {
            strMaquinaAlta: POSRegister1?.strMaquinaAlta || "",
            strUsuarioPOS: POSRegister1?.strUsuarioPOS || "",
            datFechaAlta: this.datacierre?.datFechaInicioTurno
              ? new Date(this.datacierre.datFechaInicioTurno + "Z")
              : null,
            strTerminal: this.nombreTerminal?.strNombre || "",
            dblImporteEntregado,
            dblDiferencia: dblImporteEntregado - (this.datacierre?.dblVenta || 0),
            dblImporte: dblImporteEntregado,
            dblVenta: this.datacierre?.dblVenta || 0,
            intTotalOrdenesVenta: this.datacierre?.intTotalOrdenesVenta || 0,
            intTotalPlatillosVenta: this.datacierre?.intTotalPlatillosVenta || 0,
            intCortesiaCta: this.datacierre?.intCortesiaCta || 0,
            intCortesiaPlat: this.datacierre?.intCortesiaPlat || 0
          };

          console.log("POSREGISTER ANTES DE DATOS GLOBAL")

          console.log(POSRegister)
          console.log(this.datacierre)


          POSRegister.pagos = await this.registerFunctions.pagosReimpresion(POSRegister1.intPOSRegisterPadre) || [];
          POSRegister.salidas = await this.registerFunctions.salidasReimpresion(POSRegister1.intPOSRegisterPadre);
          POSRegister.dblVentas = await this.registerFunctions.ventasReimpresion(POSRegister1.intPOSRegisterPadre);

          // Complementar con datos del corte
          this.datacierreCorte = await this.registerFunctions.corteGlobal(
            POSRegister1.intPOSRegisterPadre || 0,
            POSRegister1.datFechaInicio
          );

          Object.assign(POSRegister, {

            //dblVenta: this.datacierreCorte?.dblVenta || 0,
            dblVenta: this.datacierre?.dblVentaConImpuesto || 0,
            //dblVentaSinImpuesto: this.datacierreCorte?.dblVentaSinImpuesto || 0,
            dblVentaSinImpuesto: this.datacierre?.dblVentaSinImpuesto || 0,
            intEnvios: this.datacierreCorte?.intEnvios || 0,
            dblEnvios: this.datacierreCorte?.dblEnvios || 0,
            //intEnvios: this.datacierreCorte?.intEnvios || 0,
            // dblEnvios: this.datacierreCorte?.dblEnvios || 0,
            dblVentaConImpuesto: this.datacierre?.dblVenta || 0,
            //dblVentaConImpuesto: this.datacierreCorte?.dblVentaConImpuesto || 0,
            intPromCta: this.datacierreCorte?.intPromCta || 0,
            dblPromCta: this.datacierreCorte?.dblPromCta || 0,
            intCancelacionCta: this.datacierreCorte?.intCancelacionCta || 0,
            dblCancelacionCta: this.datacierreCorte?.dblCancelacionCta || 0,
            intCancelacionPlat: this.datacierreCorte?.intCancelacionPlat || 0,
            dblCancelacionPlat: this.datacierreCorte?.dblCancelacionPlat || 0,
            intDescuentoCta: this.datacierreCorte?.intDescuentoCta || 0,
            dblDescuentoCta: this.datacierreCorte?.dblDescuentoCta || 0,
            intDescuentoPlat: this.datacierreCorte?.intDescuentoPlat || 0,
            dblDescuentoPlat: this.datacierreCorte?.dblDescuentoPlat || 0,
            intDevolucionCta: this.datacierreCorte?.intDevolucionCta || 0,
            dblDevolucionCta: this.datacierreCorte?.dblDevolucionCta || 0,
            intDevolucionPlat: this.datacierreCorte?.intDevolucionPlat || 0,
            dblDevolucionPlat: this.datacierreCorte?.dblDevolucionPlat || 0,
            intOrdenesDomicilio: this.datacierreCorte?.intOrdenesDomicilio || 0,
            dblTotalDomicilio: this.datacierreCorte?.dblTotalDomicilio || 0,
            intOrdenesLLevar: this.datacierreCorte?.intOrdenesLLevar || 0,
            dblTotalLLevar: this.datacierreCorte?.dblTotalLLevar || 0,
            intOrdenesMesa: this.datacierreCorte?.intOrdenesMesa || 0,
            dblTotalMesa: this.datacierreCorte?.dblTotalMesa || 0,
            dblFondoCaja: this.datacierreCorte?.dblFondoCaja || 0,
            dblEntregaReal: this.datacierreCorte?.dblEntregaReal || 0,
            dblDiferencia: this.datacierre?.dblDiferencia || 0,
            intRetiroObligatorio: this.datacierreCorte?.intRetiroObligatorio || 0,
            dblRetiroObligatorio: this.datacierreCorte?.dblRetiroObligatorio || 0,
            dblComisiones: this.datacierre?.dblComisiones || 0,
            intIntentos: this.datacierre?.intIntentos || 0,
            dblCompras: this.datacierreCorte?.dblCompras || 0,
            intOrdenesRappi: this.datacierreCorte?.intOrdenesRappi || 0,
            dblTotalRappi: this.datacierreCorte?.dblTotalRappi || 0,
            intOrdenesUber: this.datacierreCorte?.intOrdenesUber || 0,
            dblTotalUber: this.datacierreCorte?.dblTotalUber || 0,
            intOrdenesDidi: this.datacierreCorte?.intOrdenesDidi || 0,
            dblTotalDidi: this.datacierreCorte?.dblTotalDidi || 0
          });

          // Preparar para imprimir
          this.printer.event = "corteTurno";
          this.printer.visible = true;
          this.printer.printable = POSRegister;
          console.log(POSRegister);
          console.log("Ticket listo para imprimir:", POSRegister);
        }
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },


    toIsoString(date) {
      var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? "+" : "-",
        pad = function (num) {
          var norm = Math.floor(Math.abs(num));
          return (norm < 10 ? "0" : "") + norm;
        };

      return (
        date.getFullYear() +
        "-" +
        pad(date.getMonth() + 1) +
        "-" +
        pad(date.getDate()) +
        "T" +
        pad(date.getHours()) +
        ":" +
        pad(date.getMinutes()) +
        ":" +
        pad(date.getSeconds()) +
        dif +
        pad(tzo / 60) +
        ":" +
        pad(tzo % 60)
      );
    },
    convertDateJSON(POSRegister) {
      if (POSRegister.DatFechaInicio.toString().includes("T")) {
        return POSRegister.DatFechaInicio.toString();
      } else {
        let x = POSRegister.DatFechaInicio.split("/");
        let POSRegister =
          x[2] + "-" + x[1] + "-" + x[0] + "T" + POSRegister.DatHora + ".511Z";
        return POSRegister;
      }
    },
  },
  async mounted() {
    console.log("ENTARDA")
    let session = new Session();
    if (!session.usuario) {
      this.$router.push("/");
    } else {
      this.loading = true;
      try {
        this.usuarios = await this.dataFunctions.loadUsuariosOrdenes();


        var admin = Cookies.get('POS_ADMIN') ? parseInt(Cookies.get('POS_ADMIN')) : 0;
        this.impresoras = await this.dataFunctions.loadImpresorasAdmin(admin);
        //this.terminal = await this.userFunctions.terminal(this.session.terminal);
        this.POSInfo = await this.dataFunctions.loadDataPOSInfo();
        this.terminalFunctions.retrieve().then((res) => {
          this.nombreTerminal = res;
        });
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style></style>
